import React from 'react';
import PropTypes from 'prop-types';
import { Col, Modal, Row } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import ButtonClose from 'utils/buttons/ButtonClose';
import { TbLicense, TbWorld } from 'react-icons/tb';
import { BsHouseDoor } from 'react-icons/bs';
import { BiBuildingHouse, BiTime } from 'react-icons/bi';
import { AiOutlinePhone, AiOutlineMail } from 'react-icons/ai';
import corner4 from 'assets/img/illustrations/authentication-corner.png';
import Background from 'components/common/Background';
import { useSelector } from 'react-redux';

const InfoRealEstateModal = ({ show, setShow, realEstate, branchOffice }) => {
  const centralOffice = branchOffice;

  const { neighborhoodsObj } = useSelector(state => state.props);

  const infoRealEstate = [
    {
      header: (
        <>
          <TbLicense size={18} className="mb-1" /> Matrícula
        </>
      ),
      value: realEstate.user.matricula || 'No especificada'
    },
    {
      header: (
        <>
          <BsHouseDoor size={18} className="mb-1" /> Dirección
        </>
      ),
      value: centralOffice?.address || 'No especificada'
    },
    {
      header: (
        <>
          <BiBuildingHouse size={18} className="mb-1" /> Barrio
        </>
      ),
      value: neighborhoodsObj[centralOffice?.barrio] || 'No especificado'
    },
    {
      header: (
        <>
          <AiOutlinePhone size={18} className="mb-1" /> Teléfono
        </>
      ),
      value: centralOffice?.phoneNumber || 'No especificado'
    },
    {
      header: (
        <>
          <AiOutlineMail size={18} className="mb-1" /> Correo
        </>
      ),
      value: centralOffice?.email ? (
        <a href={`mailto:${centralOffice?.email}`}>{centralOffice?.email}</a>
      ) : (
        'No especificado'
      )
    },
    {
      header: (
        <>
          <BiTime size={18} className="mb-1" /> Horario de atención
        </>
      ),
      value: centralOffice?.openingHours || 'No especificado'
    },
    {
      header: (
        <>
          <TbWorld size={18} style={{ marginBottom: 3 }} /> Sitio web
        </>
      ),
      value: realEstate.socialNetworks?.website ? (
        <a
          href={
            realEstate.socialNetworks?.website.includes('http')
              ? realEstate.socialNetworks?.website
              : `http://${realEstate.socialNetworks?.website}`
          }
          target="_blank"
          rel="noreferrer"
        >
          {realEstate.socialNetworks?.website}
        </a>
      ) : (
        'No especificado'
      )
    }
  ];

  return (
    <Modal
      show={show}
      onHide={() => setShow(false)}
      centered
      dialogClassName="my-modal"
      size="lg"
    >
      <Background
        image={corner4}
        className="bg-card"
        style={{
          borderTopRightRadius: '0rem',
          borderBottomRightRadius: '0rem'
        }}
      />

      <Modal.Header closeButton className="z-index-1">
        <Modal.Title>
          <FontAwesomeIcon icon={['fa-regular', 'fa-building']} /> Información
          de la inmobiliaria
        </Modal.Title>
      </Modal.Header>

      <Modal.Body
        className="d-flex flex-column flex-lg-row gap-4 align-items-center"
        style={{ width: 'fit-content' }}
      >
        <div>
          <img
            src={`${process.env.REACT_APP_CLIENT}/uploads/realestate/logo/${realEstate.logo}`}
            alt="Logo de la inmobiliaria"
            className="rounded-3 real-estate-logo-modal"
            style={{
              aspectRatio: '1/1',
              objectFit: 'cover',
              marginTop: 12
            }}
          />

          <div className="fs-3 d-flex justify-content-around align-items-center mt-2">
            {realEstate.socialNetworks?.instagram && (
              <a
                href={realEstate.socialNetworks.instagram}
                target="_blank"
                rel="noreferrer"
              >
                <FontAwesomeIcon
                  icon={['fa-brands', 'fa-instagram']}
                  style={{ color: '#E1306C' }}
                />
              </a>
            )}

            {realEstate.socialNetworks?.facebook && (
              <a
                href={realEstate.socialNetworks.facebook}
                target="_blank"
                rel="noreferrer"
              >
                <FontAwesomeIcon
                  icon={['fa-brands', 'fa-facebook']}
                  style={{ color: '#4267B2' }}
                />
              </a>
            )}

            {realEstate.socialNetworks?.twitter && (
              <a
                href={realEstate.socialNetworks.twitter}
                target="_blank"
                rel="noreferrer"
              >
                <FontAwesomeIcon
                  icon={['fa-brands', 'fa-twitter']}
                  style={{ color: '#1DA1F2' }}
                />
              </a>
            )}

            {realEstate.socialNetworks?.youtube && (
              <a
                href={realEstate.socialNetworks.youtube}
                target="_blank"
                rel="noreferrer"
              >
                <FontAwesomeIcon
                  icon={['fa-brands', 'fa-youtube']}
                  style={{ color: 'red' }}
                />
              </a>
            )}
          </div>
        </div>

        <div>
          <h3 className="text-start">{realEstate.name}</h3>

          <Row>
            {infoRealEstate.map((info, index) => (
              <Col key={index} xs={12} className="fs-1">
                <span className="p-1 m-0">
                  {info.header}: {info.value}
                </span>
              </Col>
            ))}
          </Row>
        </div>
      </Modal.Body>

      <Modal.Footer className="z-index-1">
        <ButtonClose
          text="Cerrar"
          funcion={() => setShow(false)}
          variant="secondary"
        />
      </Modal.Footer>
    </Modal>
  );
};

InfoRealEstateModal.propTypes = {
  show: PropTypes.bool.isRequired,
  setShow: PropTypes.func.isRequired,
  realEstate: PropTypes.object.isRequired,
  branchOffice: PropTypes.object.isRequired
};

export default InfoRealEstateModal;
